import { render, staticRenderFns } from "./ownLogistics.vue?vue&type=template&id=705f0743&scoped=true"
import script from "./ownLogistics.vue?vue&type=script&lang=js"
export * from "./ownLogistics.vue?vue&type=script&lang=js"
import style0 from "./ownLogistics.vue?vue&type=style&index=0&id=705f0743&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705f0743",
  null
  
)

export default component.exports